<template>
    <div class="suppliers-create-modal">
        <ModalContainer :title="$t('suppliers.add_supplier')" identifier="suppliers-create-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputText v-model="$v.supplier.name.$model" identifier="name" :label="$t('suppliers.name')"
                               :disabled="is_saving" :has-error="$v.supplier.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.supplier.name.required">
                            {{$t('validation.x_is_required',{x: $t('suppliers.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputText v-model="$v.supplier.phone.$model" identifier="phone" :label="$t('suppliers.phone')"
                               :disabled="is_saving" :has-error="$v.supplier.phone.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.supplier.phone.required">
                            {{$t('validation.x_is_required',{x: $t('suppliers.phone')})}}
                        </p>
                    </template>
                </FormInputText>
                    
                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "SuppliersCreateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        data() {
            return {
                supplier: {
                    name: null,
                    phone: null,
                },
                is_saving: false,
            }
        },
        validations: {
            supplier: {
                name: {required},
                phone: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('suppliers-create-modal', status);
            },
            save() {
                this.$v.supplier.$touch();
                if (this.$v.supplier.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                const payload = Object.assign({}, this.$v.supplier.$model);

                this.$axios.post(`suppliers`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('suppliers.success_created'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('suppliers.error_create')),
                        type: 'error',
                    });
                });
            },
        },
    }
</script>
